import { Breadcrumb } from 'antd';
import { isArray, isNull, last, map, replace, reverse, values } from 'lodash';
import React from 'react';
import commonResource from '../../../locales/th/common.json';
import { BreadcrumbWrapper } from './ProjectBreadcrumb.style';
import FeatureFlagsHelper from '../../../common/helpers/featureFlags/featureFlagsHelper';
import { mapPropertyTypeName } from '../../../common/helpers/utility/mapPropertyTypeName';

const baseUrl = '/';

interface Location {
  district?: Array<{ label: string; link: string }>;
  zone?: Array<{ label: string; link: string }>;
}

export interface AnalyticsProject {
  propertyType: string[];
  isProjectnetProject: boolean;
  location?: Location;
  title?: string;
}

interface ProjectBreadcrumbProps {
  project: AnalyticsProject;
  isProjectnetProject: boolean;
}
const getBreadcrumb = (project: AnalyticsProject) => {
  const objBreadcrumb: { name: string | string[]; link: string }[] = [
    { name: 'Home', link: baseUrl },
  ];
  const mappedPropertyTypeName = mapPropertyTypeName(
    project.propertyType,
    project.isProjectnetProject,
  );

  // display in breadcrumb only if mapping is found
  if (!isNull(project.propertyType && mappedPropertyTypeName)) {
    objBreadcrumb.push({
      name: mappedPropertyTypeName,
      link: baseUrl,
    });
  }
  if (
    Object.prototype.hasOwnProperty.call(project, 'location') &&
    !isNull(project.location) &&
    !isNull(project.location.district) &&
    project.location.district.length > 0
  ) {
    const newData = reverse(values(project.location.district));
    const lastData = last(newData);
    const districtLink = replace(
      baseUrl + (lastData?.link?.substring(1) || ''),
      /district/g,
      commonResource.location.district,
    );
    objBreadcrumb.push({ name: lastData.label, link: districtLink });
  }
  if (
    Object.prototype.hasOwnProperty.call(project, 'location') &&
    !isNull(project.location) &&
    !isNull(project.location.zone) &&
    project.location.zone.length > 0
  ) {
    const newData = reverse(values(project.location.zone));
    const lastData = last(newData);
    if (lastData?.link) {
      // We will handle zone later, for now hide this breadcrumb if zone link is unavailable
      const zoneLink = replace(
        baseUrl + (lastData.link.substring(1) || ''),
        /zone/g,
        commonResource.location.zone,
      );
      objBreadcrumb.push({ name: lastData.label, link: zoneLink });
    }
  }
  if (!isNull(project.title)) {
    objBreadcrumb.push({ name: project.title, link: null });
  }
  return objBreadcrumb;
};

const ProjectBreadcrumb: React.FC<ProjectBreadcrumbProps> = (props) => {
  const { project, isProjectnetProject } = props;
  const listBreadcrumb = getBreadcrumb(project);

  // hide breadcrumb for projectnet projects when feature flag is off
  if (
    isProjectnetProject &&
    !FeatureFlagsHelper.isActive('Toggle_SRP_ProjectNetSearch')
  ) {
    return null;
  }

  return (
    <BreadcrumbWrapper>
      <Breadcrumb className="breadcrumb" data-test={'project-breadcrumb'}>
        {map(listBreadcrumb, (v, k) => {
          if (!isNull(v.link)) {
            if (isArray(v.name)) {
              const sum = v.name.length;
              return (
                <Breadcrumb.Item key={k} data-test={'project-breadcrumb-' + k}>
                  {v.link &&
                    map(v.name, (data, index) => {
                      return (
                        <a key={index} href={v.link + data + '/'}>
                          {data + (index + 1 < sum ? ', ' : '')}
                        </a>
                      );
                    })}
                </Breadcrumb.Item>
              );
            }
            return (
              <Breadcrumb.Item key={k} data-test={'project-breadcrumb-' + k}>
                {v.link && <a href={v.link}>{v.name}</a>}
              </Breadcrumb.Item>
            );
          } else {
            return <Breadcrumb.Item key={k}>{v.name}</Breadcrumb.Item>;
          }
        })}
      </Breadcrumb>
    </BreadcrumbWrapper>
  );
};

export default ProjectBreadcrumb;
